import { render, staticRenderFns } from "./UserPropertyFavourite.vue?vue&type=template&id=59e62ad2"
import script from "./UserPropertyFavourite.vue?vue&type=script&lang=js"
export * from "./UserPropertyFavourite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports